import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

import { Component, OnDestroy, OnInit } from '@angular/core';

import { LprExportStatus } from '@lib/vehicle-intelligence';

@Component({
  selector: 'fs-vi-alpr-export-toast',
  templateUrl: './vi-alpr-export-toast.component.html',
  styleUrls: ['./vi-alpr-export-toast.component.scss'],
})
export class ViAlprExportToastComponent extends Toast implements OnInit, OnDestroy {
  protected readonly LprExportStatus = LprExportStatus;
  private readonly _destroy$ = new Subject<void>();

  private alprExportStatus: LprExportStatus;

  set exportStatus(value: LprExportStatus) {
    this.alprExportStatus = value;
  }

  get exportStatus(): LprExportStatus {
    return this.alprExportStatus;
  }

  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {
    this.exportStatus = this.toastPackage.config.payload;
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
